export const tipoProdutoEnum = {
  PRODUTO: 'PRODUTO',
  CONSULTORIA: 'CONSULTORIA',
  SEBRAETEC_FICHA_TECNICA: 'SEBRAETEC_FICHA_TECNICA',
  SAAS_PRODUTO: 'SAAS_PRODUTO',
  EVENTO: 'EVENTO',
  CURSO: 'CURSO',
  SAAS: 'SAAS'
};
